import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
export interface IGenericDialogField {
    key: string;
    label: string;
    placeholder?: string;
    defaultValue?: string;
    type?: string;
    validators?: Validators[];
}

export interface IGenericDialogData {
    title: string;
    fields: IGenericDialogField[];
    submitLabel?: string;
    onSubmitAsync?: (value: any) => Promise<void>;
}
@Component({
    selector: 'app-generic-create-dialog',
    templateUrl: './generic-create-dialog.component.html',
    styleUrl: './generic-create-dialog.component.scss',
})
export class GenericCreateDialogComponent implements OnInit {
    form!: FormGroup;
    isLoading = false;

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<GenericCreateDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IGenericDialogData
    ) {}

    ngOnInit(): void {
        const controlsConfig: { [key: string]: any } = {};
        this.data.fields.forEach((field) => {
            controlsConfig[field.key] = [field.defaultValue ?? '', field.validators || []];
        });
        this.form = this.fb.group(controlsConfig);
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    async onSubmit(): Promise<void> {
        if (!this.form.valid) return;
        if (this.data.onSubmitAsync) {
            this.isLoading = true;
            this.form.disable();
            try {
                await this.data.onSubmitAsync(this.form.value);
                this.dialogRef.close();
            } finally {
                this.isLoading = false;
                this.form.enable();
            }
        } else {
            this.dialogRef.close(this.form.value);
        }
    }
}
